/* TooltipDialog.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { TooltipPrimitive } from '@atlaskit/tooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _8 = "._p12f1mjv{max-width:300px}";
const _7 = "._c71l1mjv{max-height:300px}";
const _6 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _5 = "._vchh18uv{box-sizing:initial}";
const _4 = "._16qs1cd0{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}";
const _3 = "._1yt49l6b{padding:var(--ds-space-150,9pt) var(--ds-space-200,1pc)}";
const _2 = "._2rko12b0{border-radius:var(--ds-radius-small,4px)}";
const _ = "._11q71bhr{background:var(--ds-surface-overlay,#fff)}";
export const TooltipDialog = forwardRef((_ref, __cmplr) => {
  let {
      as: C = TooltipPrimitive,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_11q71bhr _2rko12b0 _1yt49l6b _16qs1cd0 _vchh18uv _syaz1fxt _c71l1mjv _p12f1mjv", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TooltipDialog.displayName = 'TooltipDialog';
}